import urls from 'src/sections/repository/urls';
import { createHttpRequest } from 'src/utils/http-request';

export type PrCycleBatchedResponseDTO = {
  repositories: {
    [uuid: string]: PrCycleResponseDTO;
  };
};

export type PrCycleResponseDTO = {
  linkedRepository?: {
    ari: string;
    metrics: PrCycleMetrics;
  };
  repository: {
    original: string;
  };
};

export type PrCycleMetrics = {
  low: { value: number };
  mid: { value: number };
  high: { value: number };
  recordCount: { value: number };
};

export const getPrCycleTimeBatchApi = (
  workspaceSlug: string,
  repoUuids: string[]
): Promise<PrCycleBatchedResponseDTO> => {
  const url = urls.api.internal.prBatchCycleMetrics(workspaceSlug, repoUuids);
  const headerOptions = {
    'content-type': 'application/json; charset=UTF-8',
  };
  return createHttpRequest<PrCycleBatchedResponseDTO>('GET', {
    headers: headerOptions,
  })(url);
};
